import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
  inject,
  input,
  model,
  signal,
} from '@angular/core';

@Directive({
  selector: '[libSla]',
  standalone: true,
})
export class SlaDirective implements OnInit, AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly vcr = inject(ViewContainerRef);

  isExceeded = input<boolean>(false);
  sla = input<string>('');
  isTable = input<boolean>(true);
  clockTemplate = input<TemplateRef<unknown> | null>(null);
  slaClass = model<string>('text-destructive-500');

  currentDate!: Date;
  slaDate!: Date;
  isSlaOverDate = signal(false);

  ngOnInit(): void {
    this.currentDate = new Date();
    this.slaDate = new Date(this.sla());
    if (this.sla()) {
      const isOverdue = this.currentDate.getTime() > this.slaDate.getTime();
      this.isSlaOverDate.set(isOverdue);
    }
  }

  ngAfterViewInit() {
    const span = this.el.nativeElement;
    const parent = span.parentNode;

    // Create a wrapper div to hold both elements
    const wrapper = this.renderer.createElement('div');

    // Set class for the wrapper to align items
    this.renderer.addClass(wrapper, 'flex');
    this.renderer.addClass(wrapper, 'items-center');
    this.renderer.addClass(wrapper, 'gap-x-sm');

    const isOverdue = this.isSlaOverDate();

    if (isOverdue) {
      this.slaClass.set('text-destructive-500');
      this.renderer.addClass(span, this.slaClass());
      if (this.clockTemplate()) {
        const clockTemplate = this.vcr.createEmbeddedView(
          this.clockTemplate() as TemplateRef<unknown>,
          {
            $implicit: isOverdue,
          }
        );
        this.renderer.appendChild(wrapper, clockTemplate.rootNodes[0]);
      }
    } else {
      this.slaClass.set(
        this.isTable() ? 'text-neutral-900' : 'text-neutral-700'
      );
      this.renderer.addClass(span, this.slaClass());
      if (this.clockTemplate() && this.sla()) {
        const clockTemplate = this.vcr.createEmbeddedView(
          this.clockTemplate() as TemplateRef<unknown>,
          {
            $implicit: isOverdue,
          }
        );
        this.renderer.appendChild(wrapper, clockTemplate.rootNodes[0]);
      }
    }

    // Replace the original span with our wrapper in the parent
    this.renderer.insertBefore(parent, wrapper, span);
    this.renderer.appendChild(wrapper, span);
  }
}
